import { useState, useEffect } from "react";
import { loadEmployeeListByDepartmentID } from "../services/employeeService";

const useApproveEmployeeByDepartmentID = () => {
    const [approvalEmployee, setApprovalEmployee] = useState([]);
    const [selectedApprovalEmployee, setSelectedApprovalEmployee] = useState(null);
    const [selectedApprovalEmployeeID, setSelectedApprovalEmployeeID] = useState(null);
    const [isEmployeeDataLoaded, setIsEmployeeDataLoaded] = useState(false);

    // Fetch department data
    const fetchEmployee = async (selectedID = null, departmentID) => {
       
            const para = { p_companyid: localStorage.getItem("companyid"), p_plantid: 1, p_id_department: departmentID };
            try {
                if (departmentID && departmentID !== 0) {
                    const data = await loadEmployeeListByDepartmentID(para);
                    if (data && data.length > 0) {
                        setApprovalEmployee(data);

                        const initialEmployee = data.find((dept) => dept.id_employee === selectedID) || [];
                        if (initialEmployee) {
                            setSelectedApprovalEmployee(initialEmployee);
                            setSelectedApprovalEmployeeID(initialEmployee.id_employee);
                        }

                        setIsEmployeeDataLoaded(true);
                    }
                }

            } catch (error) {
                // CallMessage("error", error.message, "Error");
            }      

    };

      

    // Function to load department based on selected ID
    const loadApprovalEmployeeByID = async (selectedID, departmentID) => {
        await fetchEmployee(selectedID, departmentID);
    };

    return {
        approvalEmployee,
        selectedApprovalEmployee,
        selectedApprovalEmployeeID,
        setSelectedApprovalEmployee,
        setSelectedApprovalEmployeeID,
        loadApprovalEmployeeByID,
    };
};

export default useApproveEmployeeByDepartmentID;